import { faBasketShopping } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useShoppingCartsContext } from 'context/ShoppingCartsContext';
import { Card, OverlayTrigger, Popover } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { tss } from 'tss-react';

import 'components/desktop/_general/MainNavigationLeft/MainNavigationLeft.scss';
import useTranslation from 'hooks/useTranslation';
import EntityType from 'types/ShoppingCart/EntityType';
import { ShoppingCart } from 'types/ShoppingCart/ShoppingCart';
import SidebarState from 'types/_general/SidebarState';

interface IProps {
	sidebarState: SidebarState;
}

const ShoppingCartQuickInfo = ({ sidebarState }: IProps) => {
	const { classes, cx } = useStyles();
	const carts = useShoppingCartsContext();
	const { tl, t } = useTranslation();
	const navigate = useNavigate();

	const defaultCart = carts.getDefault();
	if (!defaultCart) return <></>;

	const popover = (
		<Popover id="popover-basic">
			<Popover.Body>
				<button className='btn btn-outline-primary mb-2' onClick={()=> navigate('/shoppingCart/search')}>All Shopping Carts</button>
			<Card
				className={cx(
					`w-100`,
					classes.card
				)}
				onClick={() => {
					navigate('/shoppingCart/detail/' + defaultCart.id);
				}}
			>
				<Card.Body>
					<span className={classes.titleBox}>
						<span>
							<FontAwesomeIcon
								icon={faBasketShopping}
								style={{ marginRight: '8px' }}
							/>
						</span>
						{tl(defaultCart.name)}
					</span>
					<hr />
					<div>
						<div>
							{t('_general:RECIPES')}
							{': '}
							{ShoppingCart.getAmountOfEntity(defaultCart, EntityType.RECIPE)}
						</div>
						<div>
							{t('_general:MENUES')}
							{': '}
							{ShoppingCart.getAmountOfEntity(defaultCart, EntityType.MENU)}
						</div>
						<div>
							{t('_general:MENU_PLANS')}
							{': '}
							{ShoppingCart.getAmountOfEntity(defaultCart, EntityType.MENUPLAN)}
						</div>
					</div>
				</Card.Body>
			</Card>
			</Popover.Body>
		</Popover>
	);

	return (
		<div className={classes.container}>
			{sidebarState === 'closed' && (
				<OverlayTrigger trigger="click" placement="bottom" overlay={popover}>
				<button className='btn btn-outline-primary' style={{width: '2.8rem', height:'2.5rem'}}>
				<FontAwesomeIcon icon={faBasketShopping} />
				</button>
			  </OverlayTrigger>
				
			)}
		</div>
	);
};

export const useStyles = tss.create({
	container: {
		marginRight: '1rem'
	},
	icon: {
		marginTop: '2rem',
		marginLeft: '12px',
		fontSize: '22px',
		color: '#888FF9',
	},
	card: {
		borderRadius: '0.6rem',
		backgroundColor: '#f4f5ff',
		position: 'sticky',
		top: '0',
		fontSize: '14px',
		maxWidth: '16rem',
		cursor: 'pointer',
		boxShadow: '0.2rem 0.2rem 0.2rem rgba(0, 0, 0, .025)',
	},
	titleBox: {
		color: '#6066c1',
	},
});

export default ShoppingCartQuickInfo;
